import {
  SHOW_LOADING,
  HIDE_LOADING,
  OPEN_DIALOG,
  CLOSE_DIALOG,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILURE,
} from './createContact.constants'

const initialState = {
  open: false,
  loading: false,
  contact: null,
  evalForms: [],
  createdContact: null,
  errors: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADING:
      return { ...state, loading: true }
    case HIDE_LOADING:
      return { ...state, loading: false }

    case OPEN_DIALOG:
      return { ...state, open: true }
    case CLOSE_DIALOG:
      return { ...state, open: false }

    case CREATE_CONTACT_SUCCESS:
      return {
        ...state,
        createdContact: action.contact,
        open: false,
        errors: { ...state.errors, createContact: false },
      }
    case CREATE_CONTACT_FAILURE:
      return {
        ...state,
        createdContact: null,
        errors: { ...state.errors, createContact: action.error },
      }

    default:
      return state
  }
}
